import React from "react";

import { IndexDropdown } from "./Dropdown";
import IndexButton from "./Button";
import { useTranslation } from "react-i18next";
import { RESEARCH_PROJECTS, PROYGRADO, PROYPOS, BASE_NAME, COURSES, RESEARCH_PAPERS } from "../routes";

export default function Navbar(props) {
    
    const translationPrefix = 'Header'
    const { t, i18n } = useTranslation('global');
    const [navbarOpen, setNavbarOpen] = React.useState(false);

    const changeLanguage = (option) => {
        i18n.changeLanguage(option);
    }

    const scrollToSection = (alignment, sectionRef) => {
        if (sectionRef && sectionRef.current) {
            sectionRef.current.scrollIntoView(alignment);
        }
    };

    const goHome = (sectionRef) => {
        props.navigate('/')
        setTimeout(() => {
            scrollToSection({ behavior: 'smooth', block: 'start', inline: 'center'}, sectionRef)
        }, 350)
    }

    const researchLinkOptions = [ 
        {
            name: t(`${translationPrefix}.research_papers`),
            link: RESEARCH_PAPERS
        },
        {
            name: t(`${translationPrefix}.research_projects`),
            link: RESEARCH_PROJECTS
        }
    ]

    const researchButtonOptions = [
        {
            name: t(`${translationPrefix}.research_lines`),
            ref: props.researchLineRef
        },
    ]

    const teachingLinkOptions = [
        {
            name: t(`${translationPrefix}.courses`),
            link: COURSES
        },
        {
            name: t(`${translationPrefix}.proygrado`),
            link: PROYGRADO
        },
        {
            name: t(`${translationPrefix}.proypos`),
            link: PROYPOS
        }
    ]

    const teachingButtonOptions = []

    const langOptions = ['es', 'en']

    return (
        <>
        <nav className="top-0 fixed z-50 w-full flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg bg-white shadow">
            <div className="container px-4 mx-auto flex flex-wrap items-center justify-between">
            <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
                <a href={BASE_NAME} className="text-blueGray-700 text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase">
                    <img src={`${BASE_NAME}/img/logo-simple.png`} width='100' height='40' alt='logo gema' />
                </a>
                <button
                className="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
                type="button"
                onClick={() => setNavbarOpen(!navbarOpen)}
                >
                <i className="fas fa-bars"></i>
                </button>
            </div>
            <div
                className={
                "lg:flex flex-grow items-center bg-white lg:bg-opacity-0 lg:shadow-none" +
                (navbarOpen ? " block" : " hidden")
                }
                id="example-navbar-warning"
            >
                <ul className="flex flex-col lg:flex-row list-none lg:ml-auto">
                <li className="flex items-center">
                    <IndexButton name={t(`${translationPrefix}.about`)} sectionRef={props.aboutRef} goHome={goHome} />
                </li>
                <li className="flex items-center">
                    <IndexDropdown 
                    dropdownId={'research'}
                    icon={false}
                    buttonName={t(`${translationPrefix}.research`)} 
                    linkOptions={researchLinkOptions}
                    buttonOptions={researchButtonOptions}
                    goHome={goHome}
                    />
                </li>
                <li className="flex items-center">
                    <IndexDropdown 
                    buttonName={t(`${translationPrefix}.teaching`)} 
                    icon={false}
                    linkOptions={teachingLinkOptions}
                    buttonOptions={teachingButtonOptions}
                    dropdownId={'teaching'}
                    goHome={goHome} />
                </li>
                <li className="flex items-center">
                    <IndexDropdown 
                    linkOptions={langOptions}
                    icon={true}
                    buttonOptions={[]}
                    dropdownId={'lang'}
                    changeLanguage={changeLanguage}
                    goHome={goHome} />
                </li>
                </ul>
            </div>
            </div>
        </nav>
        </>
    );
}
